module.exports = __webpack_public_path__ + "img/Hyundai.6e3f6b45.png";